import axios from "axios";
import type { AxiosInstance } from "axios";
import appConfigs from "@/app/appConfigurations";
import { LS_KEY_USER } from "../const";
import LocalStorage from "../localStorage";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: appConfigs.baseUrl,
  headers: {
    Authorization: "",
    "Content-Type":'Application/json',
    // Authorization: options.token ? `Bearer ${options.token}` : "",

  },
});

export default axiosInstance;
